import React from 'react';
import { useIntl } from 'react-intl';

import { MenuItem, TextField, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { StandardTextFieldProps } from '@material-ui/core/TextField';
import classnames from 'classnames';

import messages from './messages';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      marginRight: unit * 3,
    },
    textField: {
      minWidth: 240,
    },
  });

export type PcpMode = 'pcp' | 'team';

interface SelectPCPProps extends Omit<StandardTextFieldProps, 'onChange'> {
  classes: any;
  className?: string;
  onChange: (value: PcpMode) => void;
}

const SelectPCP = ({ classes, className, onChange, ...rest }: SelectPCPProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classnames(classes.root, className)}>
      <Typography variant="body1" className={classes.label}>
        {formatMessage(messages.label)}
      </Typography>
      <TextField
        className={classes.textField}
        select
        onChange={(event) => onChange(event.target.value as PcpMode)}
        {...rest}
      >
        <MenuItem value="pcp">{formatMessage(messages.modePCP)}</MenuItem>
        <MenuItem value="team">{formatMessage(messages.modeTeam)}</MenuItem>
      </TextField>
    </div>
  );
};

export default withStyles(styles, { name: 'LumaSelectPCP' })(SelectPCP);
